<template>
<div class="chapter">
<div class="inner_page">
<div style="page-break-before:always;"></div>
<h1 class="P_Heading_1__And__Page_Break" id="auto_bookmark_table_of_contents_1"><span>PART ONE</span></h1>
<p class="P_Norm-Cen"><span>Ten years ago</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0005.vue?61e09c6a